<div class="mbl" *ngIf="state === 'ready' || state === 'off'">
  <span class="mbl__icon"><i class="fa-solid fa-calendar-check"></i></span>
  <div class="mbl__body">
    <span class="mbl__title">My Booking Link</span>
    <code class="mbl__url" *ngIf="state === 'ready'" [title]="url">{{ url }}</code>
    <span class="mbl__muted" *ngIf="state === 'off'"
      >You are not taking bookings on this project yet. Ask your admin to enable you in Project Set Up, External Calendar.</span
    >
  </div>
  <div class="mbl__actions" *ngIf="state === 'ready'">
    <button type="button" class="mbl__btn" (click)="copy()"><i class="fa-regular fa-copy"></i> Copy Link</button>
    <a class="mbl__btn mbl__btn--outline" [href]="url" target="_blank" rel="noopener"><i class="fa-solid fa-up-right-from-square"></i> Preview</a>
  </div>
</div>
